import { createCustomerContact, getCustomerContact, getCustomerContactById, updateCustomerContact, deleteCustomerContact } from '@/api/customerContact'
import Vue from 'vue'

const state = {
  customerContactList: [],
  selectCustomerContact: {},
  totalCounts: 0,
}

const actions = {

  async createCustomerContactAction({ commit }, payload) {
    try {
      const newCustomerContact = await createCustomerContact(payload.form)
      commit('CREATE_CUSTOMER_CONTACT', newCustomerContact.data)
    } catch (error) {
      throw error
    }
  },

  async getCustomerContactAction({ commit }, payload) {
    try {
      const res = await getCustomerContact(payload)
      commit('SET_CUSTOMER_CONTACT_RECORD', res.data)
      return res.data.customerContactList
    } catch (error) {
      throw error
    }
  },
  async getCustomerContactByIdAction({ commit }, id) {
    try {
      const customerContact = await getCustomerContactById(id)
      commit('SET_SELECT_CUSTOMER_CONTACT', customerContact.data)
      return customerContact.data
    } catch (error) {
      throw error.message
    }
  },

  async updateCustomerContactAction({ commit }, payload) {
    try {
      const newCustomerContact = await updateCustomerContact(payload.id, payload.data)
      commit("UPDATE_CUSTOMER_CONTACT", newCustomerContact.data)
      return newCustomerContact.data
    } catch (error) {
      throw error.message
    }
  },

  async deleteCustomerContactAction({ commit }, payload) {
    try {
      await deleteCustomerContact(payload)
      commit('DELETE_CUSTOMER_CONTACT', payload)
    } catch (error) {
      throw error.message
    }
  }
}

const mutations = {
  CREATE_CUSTOMER_CONTACT(state, payload) {
    state.customerContactList.unshift(payload)
    state.selectCustomerContact = payload
    state.totalCounts++
  },

  SET_CUSTOMER_CONTACT_RECORD(state, payload) {
    state.customerContactList = payload.customerContactList
    state.totalCounts = payload.totalCounts
  },

  SET_SELECT_CUSTOMER_CONTACT(state, payload) { 
    state.selectCustomerContact = payload
  },

  UPDATE_CUSTOMER_CONTACT(state, payload) { 
    console.log(payload);
    Vue.set(state.customerContactList, state.customerContactList.findIndex(x => x._id === payload._id), payload)
    state.selectCustomerContact = payload
  },

  DELETE_CUSTOMER_CONTACT(state, id) { 
    state.customerContactList = state.customerContactList.filter(e => e._id !== id)
    state.selectCustomerContact = {}
    state.totalCounts--
  },
}

export default {
  namespaced: true,
  state,
  actions,
  mutations,
}